import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Container,
  Typography,
  Chip,
  Button,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import EventIcon from "@mui/icons-material/Event";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { requestGetAll } from "../API/request_server";
import Heading from "./Heading";
import { useNavigate } from "react-router-dom";

const MeetingsTrainings = () => {
  const [_meetings, _setMeetings] = useState([]);
  const navigate = useNavigate();
  const getData = async () => {
    const result = await requestGetAll("meetings/getall");
    const data = result.data.map((item) => ({
      id: item.meeting_id,
      meeting_title: item.meeting_title,
      description: item.description,
      date: item.date,
      location: item.location,
      image: item.image
        ? `https://ptp.gkp.pk/backend_ptp_admin/${item.image}`
        : //? `http://localhost/backend_ptp_admin/${item.image}`
          "https://via.placeholder.com/300",
      type: item.type,
    }));
    _setMeetings(data);
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <Box sx={{ py: 1 }}>
      <Container maxWidth="lg">
        <Heading _title="Meetings & Trainings" />
        <Grid container spacing={4}>
          {_meetings.map((item) => (
            <Grid size={{ xs: 12, md: 6, lg: 4 }} key={item.id}>
              <Card
                sx={{
                  borderRadius: "24px",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  transition: "0.3s",
                  "&:hover": {
                    transform: "translateY(-8px)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={item.image}
                  alt={item.meeting_title}
                  sx={{
                    width: "100%",
                    height: 220,
                    objectFit: "cover",
                  }}
                />
                <CardContent sx={{ p: 4 }}>
                  <Chip
                    label={item.type}
                    color={item.type === "Training" ? "primary" : "success"}
                    sx={{ mb: 2, fontWeight: "bold" }}
                  />

                  <Typography variant="h5" fontWeight="bold" mb={2}>
                    {item.meeting_title}
                  </Typography>

                  <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <EventIcon color="action" fontSize="small" />
                    <Typography variant="body2">{item.date}</Typography>
                  </Box>

                  <Box display="flex" alignItems="center" gap={1} mb={2}>
                    <LocationOnIcon color="action" fontSize="small" />
                    <Typography variant="body2">{item.location}</Typography>
                  </Box>

                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      borderRadius: "12px",
                      py: 1.2,
                      textTransform: "none",
                      fontWeight: "bold",
                    }}
                    onClick={() => navigate(`/ViewMeeting/${item.id}`)}
                  >
                    View Details
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default MeetingsTrainings;
